var _rect, _g, _circle, _circle2, _circle3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 174,
    height: 174,
    viewBox: "0 0 174 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 94,
    width: 77,
    height: 77,
    rx: 6.92623,
    fill: "#F0EEEE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.971 169.014C125.225 167.76 126 166.029 126 164.116L126 100.926C126 97.101 122.899 94 119.074 94L55.8697 94C53.9571 94 52.2257 94.7752 50.9723 96.0285L123.971 169.014Z",
    fill: "#D2D2D2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86.9734,
    cy: 132.973,
    r: 25.9734,
    fill: "#A8A7A7"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.2378,
    cy: 133.32,
    r: 5.54098,
    fill: "#595959"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.709,
    cy: 133.32,
    r: 5.54098,
    fill: "#595959"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.801 135.744C112.897 134.834 112.947 133.909 112.947 132.973C112.947 118.629 101.318 107 86.9734 107C72.6287 107 61 118.629 61 132.973C61 133.909 61.0495 134.834 61.146 135.744C62.5289 122.702 73.5646 112.541 86.9734 112.541C100.382 112.541 111.418 122.702 112.801 135.744Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.279 26.8955C157.279 31.188 156.147 35.2161 154.166 38.6977C158.848 40.7133 162.127 45.3692 162.127 50.791C162.127 54.4824 160.607 57.8188 158.159 60.2086C158.935 62.4676 159.357 64.8916 159.357 67.4139C159.357 79.6547 149.433 89.5779 137.193 89.5779C137.154 89.5779 137.116 89.5778 137.077 89.5776C137.045 89.5774 137.013 89.5772 136.981 89.5769C136.456 92.9782 134.979 96.0654 132.831 98.5577C134.691 100.827 135.807 103.73 135.807 106.893C135.807 114.161 129.916 120.053 122.648 120.053C121.94 120.053 121.246 119.997 120.568 119.89C120.569 119.944 120.57 119.999 120.57 120.053C120.57 124.995 116.589 129.006 111.66 129.057C109.806 131.063 106.242 133.807 102.292 133.83C101.616 133.834 101.496 132.919 102.052 132.536C103.688 131.411 105.438 129.514 105.656 126.847C103.76 125.196 102.561 122.764 102.561 120.053C102.561 115.547 105.871 111.814 110.192 111.153C109.736 109.817 109.488 108.384 109.488 106.893C109.488 105.334 109.759 103.838 110.257 102.45C104.832 99.3476 101.176 93.5044 101.176 86.8074C101.176 82.1146 102.971 77.841 105.912 74.6359C100.592 71.5065 97.0205 65.7215 97.0205 59.1025C97.0205 49.4425 104.627 41.559 114.177 41.1141C111.23 37.1409 109.488 32.2217 109.488 26.8955C109.488 13.6984 120.186 3 133.383 3C146.58 3 157.279 13.6984 157.279 26.8955Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154 82L122.567 92.2L133.045 100L115 115L152.836 105.4L140.612 95.8L154 82Z",
    fill: "#FFDA17"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4319 87.5481L87.2905 104.467L94.2581 102.741L94.7498 115.649L103.319 96.2201L94.9702 98.0585L93.4319 87.5481Z",
    fill: "#FFDA17"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.774 136.874L117.804 130.349L119.192 137.087L106.811 137.067L125.092 146.013L123.649 137.947L133.774 136.874Z",
    fill: "#FFDA17"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.638 17.7626C143.487 16.0162 140.855 14.8025 137.917 14.3563C129.124 13.0211 120.913 19.067 119.578 27.8603C118.974 31.8386 119.881 35.6977 121.869 38.8548C117.581 35.3741 115.197 29.777 116.086 23.9217C117.421 15.1284 125.632 9.08246 134.426 10.4177C139.241 11.1489 143.232 13.9416 145.638 17.7626Z",
    fill: "#D9D9D9",
    fillOpacity: 0.33
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.83 50.5791C120.126 49.9682 118.243 49.7893 116.336 50.1496C110.629 51.228 106.877 56.7284 107.956 62.4351C108.444 65.0171 109.837 67.1989 111.745 68.7142C108.35 67.4967 105.671 64.5634 104.953 60.7633C103.874 55.0566 107.626 49.5562 113.333 48.4778C116.458 47.8873 119.521 48.7451 121.83 50.5791Z",
    fill: "#D9D9D9",
    fillOpacity: 0.33
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.767 78.7703C146.338 77.2231 147.529 75.2497 148.141 72.9661C149.973 66.1314 145.917 59.1061 139.082 57.2748C135.99 56.4462 132.858 56.8227 130.187 58.1164C133.317 55.0328 137.953 53.6417 142.504 54.8612C149.339 56.6926 153.395 63.7178 151.563 70.5526C150.561 74.2951 148 77.2045 144.767 78.7703Z",
    fill: "#D9D9D9",
    fillOpacity: 0.33
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.591 78.8624C112.412 80.0238 111.517 81.5052 111.058 83.2193C109.683 88.3501 112.728 93.6238 117.859 94.9986C120.18 95.6206 122.531 95.3379 124.536 94.3666C122.187 96.6816 118.707 97.7259 115.29 96.8104C110.159 95.4356 107.114 90.1619 108.489 85.0311C109.242 82.2218 111.164 80.0378 113.591 78.8624Z",
    fill: "#D9D9D9",
    fillOpacity: 0.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error404.7432f714811a7a3171b2dfcb485c1bd6.svg";
export { ForwardRef as ReactComponent };